// extracted by mini-css-extract-plugin
export default {"letterpressMessage":"letterpressMessage__1NBN-","sampleFlowDateField":"sampleFlowDateField__3oZ-0","optional":"optional__2T0h4"};